import React from 'react'

const BkFlowNavigationDetailsToggle = props => {
	const {
		hotelLabels,
		detailsExpanded,
		detailsEvent,
	} = props

	let arrowTypeInactive = 'arrow_drop_down',
			arrowTypeActive = 'arrow_drop_up'

	if (process.env.REACT_APP_COMPONENT_NAVIGATION_ARROW_ICON_TYPE === 'caret') {
		arrowTypeActive = 'keyboard_arrow_up'
		arrowTypeInactive = 'keyboard_arrow_down'
	}

	return (
		<div className="bk-flow-navigation__review-summary-toggle">
			<button
				aria-expanded={detailsExpanded}
				checked={ detailsExpanded }
				onClick={ detailsEvent }
				className="bk-flow-navigation__details-btn row center-xs middle-xs"
				tabIndex={ 0 }
			>
				<span className="u-font-medium u-font-bold">{ hotelLabels.details }</span>
				<span className="u-mobile-block-only">
					{ detailsExpanded === true ?
						<i className="material-icons">remove</i>
					:
						<i className="material-icons">add</i>
					}
				</span>
				<span className="u-mobile-hide-tablet-flex">
					{ detailsExpanded === true ?
						<i className="material-icons">{arrowTypeActive}</i>
						:
						<i className="material-icons">{arrowTypeInactive}</i>
					}
				</span>
			</button>
		</div>
	)
}

export default BkFlowNavigationDetailsToggle


// WEBPACK FOOTER //
// ./src/components/structure/navigation/elements/BkFlowNavigationDetailsToggle.js